import { Snackbar, SnackbarContent } from '@mui/material';
import styled from 'styled-components/macro';

export const StyledSnackBar = styled(Snackbar)`

`
export const SnackContent = styled(SnackbarContent)`
background-color: #CC3333;
font-size: 16px;
`